// (c) UseItBetter Site Responses, ver. 1.23
// (c) UseItBetter, ver. 1.2.2
var uResponses = {
    responses: {},
    helpers: {},
    c: "UseItBetter Response:"
};
window.uResponses = uResponses;
uResponses.help = require("help");

var responseLoaders = require('./responsesLoader!responses.json'); 
var delayAndWait = require('./utils/delayAndWait');
var preprocessOptions = require('./utils/preprocessOptions');
var templateRender = require('./utils/microTemplate');

uResponses.list = {}
for(var key in responseLoaders){
    uResponses.list[key] = key;    
}

function assign(destination, source){
    for(var key in source){
        destination[key] = source[key];
    }
    return destination;
}

uResponses.findElements = require('./utils/findElements');

uResponses.execute = function(responseId, options, callback, execOptions){
    execOptions = execOptions?execOptions:{};
    options = assign({}, options);
    var optionsProcessed = preprocessOptions(options, templateRender);
    if(optionsProcessed === false){
        require.ensure(["mustache"], function(require){
            var Mustache = require("mustache");
            templateRender = Mustache.render
            uResponses.execute(responseId, options, callback, execOptions);
        }, "mustache")         
        return;
    }
    callback = callback?callback:function(error){
        if(error)
            console.log(error);
    };
    var loader = responseLoaders[responseId];
    if(loader){
        loader(function(error, response){
            if(!error){
                delayAndWait(response, options, callback, execOptions)
            }
        });        
    }
    else{
        callback(new Error("Response " + responseId + " does not exist"))        
    }
}

function getScriptUrl(){
    var sourceElement = document.querySelector('script[src*="uResponses."]');
    source = sourceElement?sourceElement.getAttribute('src') :"./";
    var name = source.split('/').pop(); 
    return source.replace(name,"");    
}

__webpack_public_path__ = getScriptUrl();

function loadConsole(){
    require.ensure(["console/console"], function(require){
        var console = require("console/console");
        console.load();
        console.show();
        var pendingEvents = uResponses.pendingEvents; 
        if(!pendingEvents){
            pendingEvents = [];
        }

        //TODO - Hacky way to force first section event to exist
        var sectionEvents = pendingEvents.filter(function(event){
            return event.type == "m" && event.key == "Section";
        });
        if(!sectionEvents || sectionEvents.length == 0){
            var lastSection = sessionStorage.getItem("uDash.lastSection");
            if(lastSection){
                console.model.eventsModel.addSeparator("Section", lastSection)
            }
        }

        for(var i = 0;i < pendingEvents.length;i++){
            var pendingEvent = pendingEvents[i];
            console.addEvent(pendingEvent.type, pendingEvent.key, pendingEvent.value, pendingEvent.params);                   
        };


        delete uResponses.pendingEvents;
        uResponses.console = console;
    }, "console/console");
};


uResponses.helpers.traceEvent = function(type, key, value, params){
    if(type == 'm' || type == 'e' || type == 'a'){
        key = key.toString();
        var console = uResponses.console;
        if(console){
            if (!console.view.element.isConnected && !console.view.element.dataset.removed){
                if (!document.body) {
                    setTimeout(function(){uResponses.helpers.traceEvent(type, key, value, params);},100);
                    return;
                }
                document.body.appendChild(console.view.element);
            }
            console.addEvent(type, key, value, params);                   
        }
        else{
            var pendingEvents = uResponses.pendingEvents;
            if(!pendingEvents){
               pendingEvents = [];
               uResponses.pendingEvents = pendingEvents;
               loadConsole(); 
            }
            pendingEvents.push({
                type: type, 
                key: key,
                value: value,
                params: params
            });
        }
    }
};

window.addEventListener("beforeunload", function unload(event){
    window.removeEventListener("beforeunload", unload, false);
    var console = uResponses.console;
    if(console)
        console.save();
},false);








//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = 0
// module chunks = 0